export default "/_next/static/images/carousel-left-arrow-legacy-4524fdc33c5f1ee38bb668c2dab4d12f.svg";